<script lang="ts">
    import { Table } from 'sveltestrap'
    import {getUserMemberships, changeUserMembershipGame, deleteUserMembership} from 'src/components/cabinet/#services/memberships'
    import IconifyIcon from '@iconify/svelte'
    import deleteIcon from '@iconify/icons-fa-solid/trash-alt'
    import googlePlayIcon from '@iconify/icons-fa-brands/google'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.ts'
    import {myRole} from 'src/components/#common/myRole'
    import {doShow as showAlert} from 'src/components/#common/alert/store'

    export let userId

    let deleteMembershipModal = false
    let changeMembershipGameModal = false
    let selectedMembershipId
    let newAppId

    getUserMemberships.reset()
    $: getUserMemberships.send({ data: { userId } })

    async function changeMembershipGame() {
        try {
            await changeUserMembershipGame.request({ data: { id: selectedMembershipId, newAppId: +newAppId } })

            changeMembershipGameModal = false

            showAlert.set({
                status: 'success',
                text: 'Game for membership successfully changed'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            getUserMemberships.reset()
            getUserMemberships.send({ data: { userId: userId } })
        }
    }

    async function deleteMembership() {
        try {
            await deleteUserMembership.request({ data: {
                id: selectedMembershipId,
                userId: userId
            } })

            deleteMembershipModal = false

            showAlert.set({
                status: 'success',
                text: 'Membership successfully deleted'
            })
        } catch (err) {
            if (err.message?.includes('Action has gone on solution')) {
                deleteMembershipModal = false

                showAlert.set({
                    status: 'success',
                    text: 'Your action has been added to admin review'
                })
            } else if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            getUserMemberships.reset()
            getUserMemberships.send({ data: { userId: userId } })
        }
    }
</script>

<div class="memberships-list">
    <Table bordered striped responsive>
        <thead>
        <tr>
            <td class="text-center">Membership</td>
            <td class="text-center">Game</td>
            <td class="text-center">End date</td>
            <td class="text-center">Duration</td>
            {#if $myRole.hasValue && $myRole?.value?.methods?.includes("deleteMembership")}
            <td class="text-center">Action</td>
            {/if}
        </tr>
        </thead>
        <tbody>
        {#if $getUserMemberships.loading}
            <tr>
                <td><span class="loading memberships-loading"></span></td>
                <td><span class="loading memberships-loading"></span></td>
                <td><span class="loading memberships-loading"></span></td>
                <td><span class="loading memberships-loading"></span></td>
                {#if $myRole.hasValue && $myRole?.value?.methods?.includes("deleteMembership")}
                <td><span class="loading memberships-loading"></span></td>
                {/if}
            </tr>
        {:else if $getUserMemberships.error }
            <tr>
                <td class="text-center" colspan="5">Something went wrong. Try refreshing the page.</td>
            </tr>
        {:else if $getUserMemberships.value && $getUserMemberships.value.length > 0 }
            {#each $getUserMemberships.value as item, i}
                <tr>
                    <td style="text-transform: capitalize;">
                        <img src="/images/memberships/{item.membership.name.replace(/ /g, '_')}.svg" class="membership-icon">
                        {item.membership.name}
                        {#if item.subscriptionTokenHash}
                            <IconifyIcon style="margin: -2px 0 0 4px;color: #4285F4" icon={googlePlayIcon}/>
                        {/if}
                    </td>
                    <td>
                        <select class="form-select" value={item.appId} on:change="{(e) => {
                            changeMembershipGameModal = true
                            selectedMembershipId = item.id
                            newAppId = e.target.value
                        }}" disabled={item.subscriptionTokenHash || $myRole.hasValue && !$myRole?.value?.methods?.includes("changeMembershipGame")}>
                            <option value={3}>Crypto Cats</option>
                            <option value={5}>Crypto Dragons (Android)</option>
                            <option value={6}>Crypto Dragons (IOS)</option>
                            <option value={7}>Crypto Fox</option>
                            <option value={11}>Crypto DOGE</option>
                            <option value={13}>Elon Game</option>
                            <option value={15}>Crypto Pepe</option>
                        </select>
                    </td>
                    <td>
                        {#if item.endDate}
                            {new Date(item.endDate).toLocaleString()}
                        {/if}
                    </td>
                    <td>
                        {#if item.duration}
                            {item.duration} h
                        {/if}
                    </td>
                    {#if $myRole.hasValue && $myRole?.value?.methods?.includes("deleteMembership")}
                        <td>
                            {#if !item.subscriptionTokenHash}
                                <button class="btn btn-danger" on:click={() => {
                                    deleteMembershipModal = true
                                    selectedMembershipId = item.id
                                }}>
                                    <IconifyIcon icon={deleteIcon}/>
                                </button>
                            {/if}
                        </td>
                    {/if}
                </tr>
            {/each}
        {:else}
            <tr>
                <td class="text-center" colspan="5">No items</td>
            </tr>
        {/if}
        </tbody>
    </Table>
    <Modal bind:visible={changeMembershipGameModal}>
        <svelte:fragment slot="content">
            <div class="modal-custom__title">Change membership game</div>
            <div class="modal-custom__text">Are you sure you want to change membership game?</div>
            <div class="modal-custom__footer">
                <button class="btn btn-cancel" on:click={() => { changeMembershipGameModal = false }}>Cancel</button>
                <button class="btn btn-primary btn-success" on:click={changeMembershipGame}>Yes</button>
            </div>
        </svelte:fragment>
    </Modal>
    <Modal bind:visible={deleteMembershipModal}>
        <svelte:fragment slot="content">
            <div class="modal-custom__title">Delete membership</div>
            <div class="modal-custom__text">Are you sure you want to delete the user membership?</div>
            <div class="modal-custom__footer">
                <button class="btn btn-cancel" on:click={() => { deleteMembershipModal = false }}>Cancel</button>
                <button class="btn btn-primary btn-danger" on:click={deleteMembership}>Delete!</button>
            </div>
        </svelte:fragment>
    </Modal>
</div>

<style>
    .membership-icon {
        width: 38px;
        margin: 0 10px;
    }

    .memberships-list :global(table) {
        width: auto;
    }

    .memberships-list :global(tbody td) {
        vertical-align: middle;
        padding: 5px 25px;
        line-height: normal;
    }

    .memberships-list :global(.btn.btn-primary) {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
    }

    .memberships-loading {
        height: 24px;
        width: 100%;
        display: block;
    }
</style>
